import { NavLink, useLocation } from "react-router-dom";
import { Home, CalendarCheck, House, User } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const ITEMS = [
    { to: "/", label: "Home", icon: Home, testid: "nav-home", exact: true },
    { to: "/bookings", label: "Bookings", icon: CalendarCheck, testid: "nav-bookings" },
    { to: "/my-home", label: "My Home", icon: House, testid: "nav-my-home" },
    { to: "/profile", label: "Profile", icon: User, testid: "nav-profile" },
];

export function BottomNav() {
    const loc = useLocation();
    const { t } = useLang();
    return (
        <nav className="fixed bottom-0 left-0 right-0 z-40 mx-auto max-w-md border-t border-navy/10 bg-white px-2 pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_16px_rgba(16,42,67,0.06)]">
            <div className="flex items-stretch justify-around">
                {ITEMS.map((it) => {
                    const active = it.exact ? loc.pathname === it.to : loc.pathname.startsWith(it.to);
                    const Icon = it.icon;
                    return (
                        <NavLink
                            key={it.to}
                            to={it.to}
                            data-testid={it.testid}
                            className="flex flex-1 flex-col items-center gap-1 py-2.5 transition-colors"
                        >
                            <Icon
                                size={22}
                                strokeWidth={active ? 2.4 : 1.8}
                                className={active ? "text-teal" : "text-navy/40"}
                            />
                            <span className={`text-[11px] font-semibold ${active ? "text-teal" : "text-navy/45"}`}>
                                {t(it.label)}
                            </span>
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
}
